const googleReviewsInit = async () => {
    const reviewBlocks = Array.from(document.querySelectorAll('.bn-google-reviews'));

    if (!reviewBlocks.length) {
        return;
    }

    if (!window.google?.maps) {
        return;
    }

    let Place;

    try {
        ({ Place } = await google.maps.importLibrary('places'));
    } catch {
        return;
    }

    reviewBlocks.forEach(async (reviewBlock) => {
        const placeId = reviewBlock.dataset.placeId;

        if (!placeId) {
            return;
        }

        try {
            const place = new Place({ id: placeId });

            await place.fetchFields({
                fields: ['rating', 'userRatingCount', 'googleMapsURI'],
            });

            if (!place.rating) {
                return;
            }

            const card = reviewBlock.querySelector('.bn-google-reviews__card');
            const rating = reviewBlock.querySelector('.bn-google-reviews__rating');
            const count = reviewBlock.querySelector('.bn-google-reviews__count');
            const starsFill = reviewBlock.querySelector('.bn-google-reviews__stars-fill');
            const reviewCount = Number(place.userRatingCount || 0);

            rating.textContent = place.rating.toFixed(1);
            count.textContent = `(${new Intl.NumberFormat(document.documentElement.lang || 'pl-PL').format(reviewCount)})`;
            starsFill.style.width = `${Math.min(place.rating, 5) / 5 * 100}%`;

            if (place.googleMapsURI) {
                card.href = place.googleMapsURI;
            }

            card.hidden = false;
        } catch {
            return;
        }
    });
};

document.addEventListener('DOMContentLoaded', googleReviewsInit);